import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { tap, take, switchMap, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Store } from '@ngrx/store';
import * as fromStore from '@usimweb/state/store';

@Injectable()
export class CompareGuard {
  constructor(private store: Store<fromStore.DashboardState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(fromStore.getCompareLoaded).pipe(
      tap((loaded) => {
        let modelIds: string[] = [];

        const entries = Object.entries(route.params);
        entries.forEach((x: string[], index: number) => {
          if (index !== 0) {
            modelIds.push(x[1]);
          }
        });

        const id = route.params['id'];
        this.store.dispatch(new fromStore.CompareVersions(modelIds, 'filling'));

        if (!loaded) {
          this.store.dispatch(new fromStore.LoadVersions(id));
        }
      })
      // unsubscribe the observable if loaded true
      // filter((loaded) => loaded === true),
      //take(1)
    );
  }
}
